// = Libs =
import { FC, useEffect, useState } from 'react';

// = Styles =
// = Imports =
import { OptionModel } from '@/common/components/ui/select/select.types';
import Select from '@/common/components/ui/select/select';
import {
  getAggregated,
  getQuestions,
  QuestionModel,
} from '@/services/question.service';
import Button from '@/common/components/ui/buttons/button/button';
import classes from './import-aggregate.module.scss';
import Input from '@/common/components/ui/input/input';

const ImportAggregate: FC<{
  onSuccess: (value: any) => any;
  defaultPollId?: number;
  defaultQuestionId?: number;
  polls: OptionModel[];
}> = (props) => {
  const { onSuccess, defaultPollId, defaultQuestionId, polls } = props;
  const [poll, setPoll] = useState<number | undefined>(defaultPollId);
  const [question, setQuestion] = useState<number | undefined>(
    defaultQuestionId
  );
  const [questions, setQuestions] = useState<OptionModel[]>([]);
  const [aggregated, setAggregated] = useState();

  useEffect(() => {
    if (!poll) return;

    const fetchData = async () => {
      const questions = (await getQuestions(poll as number)).data?.items || [];
      setQuestions(
        questions.map((q: QuestionModel) => {
          return {
            value: q.questionId,
            label: q.title,
          };
        })
      );
    };
    fetchData();
  }, [poll]);

  useEffect(() => {
    if (!question || !poll) return;

    const fetchData = async () => {
      const aggr = (await getAggregated(poll, question)).data?.result;
      setAggregated(aggr);
      console.log(aggr);
    };
    fetchData();
  }, [question]);

  return (
    <div className={classes.form}>
      <Select
        options={polls}
        isSearchable={true}
        onChange={(nv) => {
          setPoll(Number((nv as OptionModel).value));
        }}
      />
      <Select
        options={questions}
        isSearchable={true}
        onChange={(nv) => {
          setQuestion(Number((nv as OptionModel).value));
        }}
      />
      <div className={classes.preview}>
        <Input
          value={aggregated}
          disabled={true}
          placeholder={'Предпросмотр'}
          fullWidth
        />
        <Button
          color={'primary'}
          onClick={() => {
            onSuccess(aggregated);
          }}>
          Импортировать
        </Button>
      </div>
    </div>
  );
};

export default ImportAggregate;
